<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="column"/>
          <h2 class="font-bold ml-2">{{ $t('app.dynamic_columns') }}</h2>
            <base-tooltip-icon size="sm" :section="$t('app.dynamic_columns')" :content="$t('tooltip.columns_dynamic')" class="ml-2"/>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <h2 class="dark:text-darkblue-200 font-bold mb-4 text-sm">Metadatos dinámicos</h2>
        <el-form
          ref="ruleForm"
        >
          <div>
            <AccessibleElSelect
              v-model="form.metadato1"
              prop="metadato1"
              :options="metadatosForAccessibleSelect"
              :withFormItem="true"
              placeholder="No definido"
              id-prefix="columnaspanel"
            >
              <template slot="label">Metadato adicional</template>
            </AccessibleElSelect>
          </div>
          <div>
            <AccessibleElSelect
              v-model="form.metadato2"
              prop="metadato2"
              :options="metadatosForAccessibleSelect"
              :withFormItem="true"
              placeholder="No definido"
              id-prefix="columnaspanel"
            >
              <template slot="label">Metadato adicional</template>
            </AccessibleElSelect>
          </div>
          <div>
            <AccessibleElSelect
              v-model="form.metadato3"
              prop="metadato3"
              :options="metadatosForAccessibleSelect"
              :withFormItem="true"
              placeholder="No definido"
              id-prefix="columnaspanel"
            >
              <template slot="label">Metadato adicional</template>
            </AccessibleElSelect>
          </div>
          <div>
            <AccessibleElSelect
              v-model="form.metadato4"
              prop="metadato4"
              :options="metadatosForAccessibleSelect"
              :withFormItem="true"
              placeholder="No definido"
              id-prefix="columnaspanel"
            >
              <template slot="label">Metadato adicional</template>
            </AccessibleElSelect>
          </div>
          <div>
            <AccessibleElSelect
              v-model="form.metadato5"
              prop="metadato5"
              :options="metadatosForAccessibleSelect"
              :withFormItem="true"
              placeholder="No definido"
              id-prefix="columnaspanel"
            >
              <template slot="label">Metadato adicional</template>
            </AccessibleElSelect>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyColumns"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import { i18n } from '@/i18n'
import { getCamposMetadatos } from '@/services/notifications/getCamposMetadatos'
import { getMisMetadatosDinamicos } from '@/services/searches/getMisMetadatosDinamicos'
import { setMetadatosDinamicos } from '@/services/searches/setMetadatosDinamicos'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'columns-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    },
    vuexnamespace: {
      type: String,
      default: ''
    },
    idVista: {
      type: Number,
      default: -1
    }
  },
  data: function () {
    return {
      isOpen: this.panelOpen,
      searches: [],
      metadatos: [],
      form: {
        metadato1: '',
        metadato2: '',
        metadato3: '',
        metadato4: '',
        metadato5: '',
      }
    }
  },
  watch: {
    panelOpen: function (value, oldValue) {
      if (value) {
        this.updateData()
      } 
    }
  },
  mounted: async function () {
    // this.updateData()
  },
  computed: {
    metadatosForAccessibleSelect: function () {
      return this.metadatos.map(item => ({
        id: item,
        name: item,
        value: item
      }))
    }
  },
  methods: {
    cleanData () {
      this.metadatos = []
      this.form.metadato1 = ''
      this.form.metadato2 = ''
      this.form.metadato3 = ''
      this.form.metadato4 = ''
      this.form.metadato5 = ''
    },
    updateData: async function () {
      this.cleanData()
      this.handleGetCamposMetadatos()
      this.handleGetMisMetadatosDinamicos()
    },
    handleGetCamposMetadatos: async function () {
      try {
        const response = await getCamposMetadatos()
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.metadatos = response.Respuesta
        }
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        // this.$store.commit('setIsLoading', false)
      }
    },
    handleGetMisMetadatosDinamicos: async function () {
      try {
        const response = await getMisMetadatosDinamicos()
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.form.metadato1 = response.metadatos?.Metadato1
          this.form.metadato2 = response.metadatos?.Metadato2
          this.form.metadato3 = response.metadatos?.Metadato3
          this.form.metadato4 = response.metadatos?.Metadato4
          this.form.metadato5 = response.metadatos?.Metadato5
        }
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        // this.$store.commit('setIsLoading', false)
      }
    },
    panelOpenHandler: function (data) {
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    applyColumns: async function () {
      await this.handleSetMetadatosDinamicos()
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    handleSetMetadatosDinamicos: async function () {
      try {
        const payload = {
          metadato1: this.form.metadato1,
          metadato2: this.form.metadato2,
          metadato3: this.form.metadato3,
          metadato4: this.form.metadato4,
          metadato5: this.form.metadato5,
        }
        const response = await setMetadatosDinamicos(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.$store.commit(this.vuexnamespace + '/showHideColumn', { columnField: 'Metadato1', hidden: !this.form.metadato1 })
          this.$store.commit(this.vuexnamespace + '/showHideColumn', { columnField: 'Metadato2', hidden: !this.form.metadato2 })
          this.$store.commit(this.vuexnamespace + '/showHideColumn', { columnField: 'Metadato3', hidden: !this.form.metadato3 })
          this.$store.commit(this.vuexnamespace + '/showHideColumn', { columnField: 'Metadato4', hidden: !this.form.metadato4 })
          this.$store.commit(this.vuexnamespace + '/showHideColumn', { columnField: 'Metadato5', hidden: !this.form.metadato5 })

          this.sendUpdatedColumns(this.$store.getters[this.vuexnamespace+ '/getKendo'].columns)

          this.doFeedback('Columnas establecidas correctamente', 'success')
        }
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        // this.$store.commit('setIsLoading', false)
      }
    }
  }
}
</script>
